export default __webpack_public_path__ + "static/media/background-splash-bottom.0b4e2d51.svg";